import script from "./CreateOrganizationModel.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrganizationModel.vue?vue&type=script&setup=true&lang=js"

import "./CreateOrganizationModel.vue?vue&type=style&index=0&id=3c19fa2b&scoped=true&lang=css"
script.__scopeId = "data-v-3c19fa2b"

export default script